import React from 'react';
import { Form, Input, Textarea, Checkbox } from 'formsy-react-components';
import { Http, i18n, merge } from 'common';

import {
  Box, Grid, Column, Icon, Alert, Footer,
  AdminForm, AdminInput, AdminTagsInput, AdminButton
} from '../components';


export default
class WhitelistEdit extends AdminForm {
  config = {
    url: 'api/whitelist/',
    relation: {url: 'api/clients/'},
    backUrl: '/'
  }

  onBeforeSubmit = (data) => {
    const { initialObject, relatedObject } = this.state;

    if (data.allowedScopes == null)
      data.allowedScopes = initialObject.allowedScopes||relatedObject.scope;
  }

  render() {
    const { initialObject, relatedObject, isBlank } = this.state;
    const clientId = initialObject.clientId||relatedObject.clientId;
    const clientDetailsId = initialObject.clientDetailsId||relatedObject.id;
    const presets = merge(relatedObject.scope||[], initialObject.allowedScopes);
    const scopes = initialObject.allowedScopes||presets;

    return (
      <Box>
        <header className="box__header">
          {i18n('whitelist-form.title' + (isBlank ? '.new':'.edit'))}
        </header>

        <div className="box__content">
          <Form ref="form" onSubmit={this.onSubmit}>
            <Grid columns="2">
              <Column>
                <Input name="clientDetailsId" type="hidden" value={`${clientDetailsId}`} />
                <label>
                  <span className='mr2'>ClientID</span>
                  <input value={clientId} label={i18n('whitelist-form.fields.client')} placeholder="" disabled />
                </label>
              </Column>

              <Column>
              </Column>
            </Grid>

            <hr />

            <div>
              <AdminTagsInput name="allowedScopes" title={i18n('whitelist-form.fields.allowed-scopes')}
                              newItemValidations="isScope" presets={presets} value={scopes}
                              placeholder={i18n('whitelist-form.placeholders.allowed-scopes')}
                              hint={i18n('whitelist-form.hints.allowed-scopes')} />
            </div>

            <Footer className="txtcenter">
              <div className="mt2">
                <AdminButton type="submit" className="mr2" />
                <AdminButton type="cancel" onClick={this.onCancel} />
              </div>
            </Footer>
          </Form>
        </div>
      </Box>
    );
  }
};
